import React from 'react';

const SignupTermsNotice = () => {
  return (
    <div className="text-sm [&_a]:text-[length:inherit] [&_a]:underline text-gray-110">
      By signing up, you agree to our{' '}
      <a href="https://canny.io/terms" target="_blank" rel="noopener">
        terms of service
      </a>{' '}
      and{' '}
      <a href="https://canny.io/privacy" target="_blank" rel="noopener">
        privacy&nbsp;policy.
      </a>
    </div>
  );
};

export default SignupTermsNotice;
